import { styled } from "styled-components";

export const StyledFooterText = styled.p`
  width: auto;
  text-align: center;
  margin-top: 60px;
`;
export const FooterContainer = styled.div`
  background: var(--backgroundColor);
`;

export const FooterWithLink = styled.p`
  margin-top: 30px;
  text-align: center;
`;
